import { useState, useEffect, useCallback } from 'react';
import PresentationContainer from 'react-presentation-container';

import Video from './Video.component';

export default PresentationContainer({
  component: Video,
  controller: function VideoController({ getSource }) {
    const [source, setSource] = useState();
    const [isVisible, setIsVisible] = useState(false);
    const [isSourceLoading, setIsSourceLoading] = useState(!!getSource);

    const _loadSource = useCallback(async () => {
      setIsSourceLoading(true);
      const result = await getSource();
      setSource(result);
      setIsSourceLoading(false);

      if (result) {
        setIsVisible(true);
      }
    }, [getSource]);

    useEffect(() => {
      if (getSource) {
        _loadSource();
      }
    }, [_loadSource, getSource]);

    return {
      source,
      isSourceLoading,
      isVisible
    };
  }
});
